module.exports = __webpack_public_path__ + "static/media/prontuario-inteligente.06bfdadf.svg";